import React from 'react';
interface SectionCardProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  bodyClassName?: string;
}
export function SectionCard({
  title,
  description,
  actions,
  children,
  bodyClassName = 'p-4'
}: SectionCardProps) {
  return <section className="rounded-sm border border-border bg-card" data-id="element-571" data-mp="18xlflebf46a2">
      <header className="flex flex-wrap items-start justify-between gap-3 border-b border-border px-4 py-3" data-id="element-572" data-mp="18zz7xfepr4dx">
        <div className="min-w-0" data-id="element-573" data-mp="1wptj7sjdwkw2">
          <h2 className="text-[13px] font-semibold tracking-tight text-foreground" data-id="element-574" data-mp="20paniin2rbzn">{title}</h2>
          {description && <p className="mt-0.5 text-[12px] leading-relaxed text-muted-foreground" data-id="element-575" data-mp="1mwup5v54c252">
              {description}
            </p>}
        </div>
        {actions && <div className="flex shrink-0 items-center gap-2" data-id="element-576" data-mp="2flrxb5fm8ik3">{actions}</div>}
      </header>
      <div className={bodyClassName} data-id="element-577" data-mp="2kcrw6g8apap8">{children}</div>
    </section>;
}